import {BrowserView} from "react-device-detect";
import ContactBar from "./components/contactBar";
import MainBar from "./components/mainBar";

import "./style.scss";
import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

const Header = () => {
    const [isScroll , setIsScroll] = useState(false)
    const {pathname} = useLocation()
    const path = pathname === '/' ? true : false


    useEffect(()=>{
        window.addEventListener('scroll', handleScroll);
    }, [document.body.scrollTop])
    const  handleScroll = () => {
        if (window.scrollY > 0){
            setIsScroll(true)
        } else {
            setIsScroll(false)
        }
    };
    return (
        <header className={ path ? isScroll ? "header-template-4-light" : "header-template-4-transparent"  : "header-template-4-light position-sticky"   }>
            {/*<ContactBar/>*/}
            <MainBar path={path} isScroll={isScroll}/>
        </header>
    );
}

export default Header;